/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer/index';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

/**
 * 公共组件
 */
import CommonTable from './CommonTable';
import CommonModalForm from './CommonModalForm';

export { AvatarDropdown, AvatarName, Footer, Question, SelectLang };
export { CommonTable };
export { CommonModalForm };
export type {
  CommonTableProps,
  FormFieldConfig,
  TableActionConfig,
} from './CommonTable';
export type {
  CommonModalFormProps,
  ModalFormFieldConfig,
  ModalFormActionConfig,
} from './CommonModalForm';
